export const CharacterInfo = {
  TANK: [
    {
      name: "디바",
      color: "rgb(193,86,140)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "둠피스트",
      color: "rgb(71,20,10)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "라마트라",
      color: "rgb(95,76,139)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "라인하르트",
      color: "rgb(95,104,115)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "레킹볼",
      color: "rgb(175,87,0)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "로드호그",
      color: "rgb(131,78,7)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "마우가",
      color: "rgb(168,39,1)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "시그마",
      color: "rgb(90,102,102)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "오리사",
      color: "rgb(7,79,0)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "윈스턴",
      color: "rgb(102,104,126)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "자리야",
      color: "rgb(179,65,120)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "정커퀸",
      color: "rgb(60,114,151)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "해저드",
      color: "rgb(106,56,142)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
  ],
  DPS: [
    {
      name: "겐지",
      color: "rgb(92,192,0)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "리퍼",
      color: "rgb(62,0,16)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "메이",
      color: "rgb(49,114,182)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "바스티온",
      color: "rgb(65,83,55)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "벤처",
      color: "rgb(88,69,54)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "소전",
      color: "rgb(165,44,31)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "솔저:76",
      color: "rgb(37,49,76)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "솜브라",
      color: "rgb(46,13,121)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "시메트라",
      color: "rgb(83,135,151)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "애쉬",
      color: "rgb(36,35,31)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "에코",
      color: "rgb(99,152,196)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "위도우",
      color: "rgb(101,37,102)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "정크랫",
      color: "rgb(182,130,13)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "캐서디",
      color: "rgb(128,43,43)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "토르비욘",
      color: "rgb(135,52,42)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "트레이서",
      color: "rgb(162,86,0)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "파라",
      color: "rgb(18,77,146)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "프레야",
      color: "rgb(59,117,194)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "한조",
      color: "rgb(131,123,62)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
  ],
  SUP: [
    {
      name: "우양",
      color: "rgb(47,90,182)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "라이프위버",
      color: "rgb(173,124,140)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "루시우",
      color: "rgb(76,151,20)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "메르시",
      color: "rgb(195,189,131)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "모이라",
      color: "rgb(93,53,175)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "바티스트",
      color: "rgb(37,100,122)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "브리기테",
      color: "rgb(81,28,19)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "아나",
      color: "rgb(43,70,114)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "일리아리",
      color: "rgb(119,101,59)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "젠야타",
      color: "rgb(192,182,78)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "주노",
      color: "rgb(80,17,118)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
    {
      name: "키리코",
      color: "rgb(160,64,75)",
      img: require("../asset/img/jipgaebugprofile.png"),
    },
  ],
};
